import angular from 'angular';

angular.module('commonServices').filter('cxTypeaheadHighlight', [
  '$sce',
  '$injector',
  '$log',
  function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      if (query) {
        var items = query.split(' ');
        var matches = [];
        for (var i = 0; i < items.length; i++) matches.push('(' + escapeRegexp(items[i]) + ')');

        matchItem = ('' + matchItem).replace(
          new RegExp(matches.join('|'), 'gi'),
          '<strong>$&</strong>',
        ); // Replaces the capture string with a the same string inside of a "strong" tag
      }
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  },
]);
//Override default template
angular.module('uib/template/typeahead/typeahead-match.html', []).run([
  '$templateCache',
  function($templateCache) {
    $templateCache.put(
      'uib/template/typeahead/typeahead-match.html',
      '<a href\n' +
        '   tabindex="-1"\n' +
        '   ng-bind-html="match.label | sanitize | cxTypeaheadHighlight:query"\n' +
        '   ng-attr-title="{{match.label}}"></a>\n' +
        '',
    );
  },
]);
